export default __webpack_public_path__ + "static/men-technology-zoom-seed-635ade562b9c352d4e22bc3e866b4f9c.png";